import { Sparkles, BedDouble, UtensilsCrossed, HeartHandshake } from "lucide-react";
import { Reveal } from "./Reveal";

const PILLARS = [
  { icon: Sparkles, title: "Celebrations", text: "A dedicated venue for weddings and special events.", testid: "why-pillar-celebrations" },
  { icon: BedDouble, title: "Stay", text: "Comfortable rooms for guests and families.", testid: "why-pillar-stay" },
  { icon: UtensilsCrossed, title: "Dining", text: "Delicious food in a welcoming atmosphere.", testid: "why-pillar-dining" },
  { icon: HeartHandshake, title: "Hospitality", text: "A convenient and comfortable experience from arrival to departure.", testid: "why-pillar-hospitality" },
];

export const WhyChooseUs = () => (
  <section id="why-us" data-testid="why-choose-us-section" className="bg-navy py-16 sm:py-20 lg:py-28">
    <div className="section-wrap">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="eyebrow">Why Choose Us</p>
        <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-cream sm:text-4xl lg:text-5xl">
          Everything You Need, Under One Roof
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 100}>
            <div
              data-testid={p.testid}
              className="group h-full rounded-md border border-cream/10 bg-navy-dark p-7 text-center transition-colors duration-300 hover:border-gold/40"
            >
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-gold/30 bg-gold/10 transition-colors duration-300 group-hover:bg-gold/20">
                <p.icon className="h-6 w-6 text-gold" />
              </span>
              <h3 className="mt-5 font-serif text-xl font-semibold text-cream">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/65">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
